import { Component, OnInit, ViewChild,ElementRef  } from '@angular/core';
import { DatePipe } from '@angular/common'
import { ReportService } from '../../_service/report.service';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from '../../_service/leads.service';
import { ActivatedRoute, Router  } from '@angular/router';
import { NgModel } from '@angular/forms';
@Component({
  selector: 'app-statuswise-report',
  templateUrl: './statuswise-report.component.html',
  styleUrls: ['./statuswise-report.component.css']
})
export class StatuswiseReportComponent implements OnInit {
    start_date:string='';end_date:string='';allUsers=[];loading:boolean=false;loaded:boolean=false;myrole:string;userId:any;treatment_catergory_access:any;bds=[];bds_copy=[];
    allStatus=[];circle:string;circles=[];leadStatus=[];lead_status=[1,3,10,4];category_filter:string;bd_filter:string;displayFollowUpByLeadDate:string;treatments:any;treatment_filter:string;lead_source_filter:string;
    constructor(private leadapi:LeadsService,private reportapi:ReportService,private sharedapi:SharedService,public datepipe: DatePipe) { }

    @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
    @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;
    ngOnInit(): void
    {
        
        this.sharedapi.getRole()
        .subscribe((item:string) => {this.myrole=item;});
        this.myrole = localStorage.getItem('role');
        this.userId = localStorage.getItem('loginuserId');
        this.treatment_catergory_access = localStorage.getItem('treatment_catergory_access');

        if(this.myrole=='1' || this.userId=='3')
        {
            this.getcircle();
        }
        // if(this.myrole=='3')
        // {
        //     this.category_filter = localStorage.getItem('treatment_catergory_access');
        // }
        this.getleadStatus()
        
        this.getTreatments();
        this.getStatusWiseReport();
        this.getbds();
    }

    async getbds(status=1)
    {
        this.leadapi.getbds(status).subscribe((data:any) => {
            if(data.status)
            {
                this.bds = data.data;
                this.bds_copy = this.bds;
            }else{
                this.bds = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    selectAll(select: NgModel) {
        let values: any[] = []; // array which will contain all values
        // loop through all groups and add their items' values to the array
        for(let group of this.leadStatus){
          values.push(group.id);
        }
        console.log(values);
        //let data = values.map(x=>`${x}`).toString().split(',');
        select.update.emit(values);
        console.log(values);
        this.getStatusWiseReport();

      }
    
      deselectAll(select: NgModel) {
        select.update.emit([]);
        this.getStatusWiseReport();
      }
     
    // ngAfterViewInit() {
    //     this.getStatusWiseReport();
    // }  

    clearDate()
    {
        this.dateRangeStart.nativeElement.value = "";
        this.dateRangeEnd.nativeElement.value = "";
        this.start_date = '';
        this.end_date = '';
        this.displayFollowUpByLeadDate='';
        this.getStatusWiseReport();
    }

    dateRangeChange(date1,date2)
    {
        if(date2.value)
        {
            this.start_date = date1.value;
            this.end_date = date2.value;
            this.getStatusWiseReport();
        }
    }

    async getleadStatus()
    {
        await this.leadapi.getLeadStatus().subscribe((data:any) => {
            if(data.status)
            {
                this.leadStatus = data.data;
            }else{
                this.leadStatus = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getStatusWiseReport()
    {
        if(this.myrole=='1' || this.myrole=='3' || this.myrole=='6' || this.myrole=='9' || this.myrole=='15' || this.myrole=='18')
        {
            this.allUsers = [];this.loaded = false;
            let qString = 'lead_status='+this.lead_status+'&circle='+this.circle+'&date_range='+this.start_date+'-'+this.end_date+'&category_filter='+this.category_filter+'&displayFollowUpByLeadDate='+this.displayFollowUpByLeadDate+'&treatment_filter='+this.treatment_filter+'&lead_source_filter='+this.lead_source_filter+'&bd_filter='+this.bd_filter;
            this.loading = true;
            await this.reportapi.getStatusWiseReport(qString).subscribe((data:any) => {
                this.loaded = true;
                this.loading = false;
                if(data.status)
                {
                    this.allUsers = data.data;
                    this.allStatus = data.statuses;
                }
            }, error => {
                this.loading = false;
                this.sharedapi.checkError(error);
            });
        }
    }

    async getcircle()
    {
        await this.leadapi.getcircles().subscribe((data:any) => {
            if(data.status)
            {
                this.circles = data.data;
            }else{
                this.circles = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getTreatments()
    {
        await this.leadapi.getTreatments().subscribe((data:any) => {
            if(data.status)
            {
                this.treatments = data.data;
            }else{
                this.treatments = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

}
